import { render, staticRenderFns } from "./swuserregister.vue?vue&type=template&id=dd240c28&scoped=true&"
import script from "./swuserregister.vue?vue&type=script&lang=js&"
export * from "./swuserregister.vue?vue&type=script&lang=js&"
import style0 from "./swuserregister.vue?vue&type=style&index=0&id=dd240c28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd240c28",
  null
  
)

export default component.exports